import Subscribe from "../components/Subscribe";
import translations from "../translations/english.json";
import { Grid } from "@mui/material";
import Wrapper from "../components/Wrapper";

const SubscribeEn = () => {
  return (
    <div>
      <Wrapper lang="en">
        <Grid container alignItems="center" justifyContent="center">
          <Subscribe translations={translations.subscribe} lang="en" />
        </Grid>
      </Wrapper>
    </div>
  );
};

export default SubscribeEn;
